"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.checkQueueProcessStatus = exports.SocketQueueText = exports.SocketQueueMapping = void 0;
var _genericFunction = require("../genericFunction");
var SocketQueueText = "Process is in Queue.";
exports.SocketQueueText = SocketQueueText;
var checkQueueProcessStatus = function checkQueueProcessStatus(config) {
  return SocketQueueMapping !== null && SocketQueueMapping !== void 0 && SocketQueueMapping.find(function (item) {
    return item.url === (config === null || config === void 0 ? void 0 : config.url.split("?")[0]) && item.method.toLocaleLowerCase() === (config === null || config === void 0 ? void 0 : config.method);
  }) ? true : false;
};
exports.checkQueueProcessStatus = checkQueueProcessStatus;
var SocketQueueMapping = [{
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/print-bridge/report",
  method: "GET"
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/site/snapshot/live",
  method: "GET"
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/report/snapshot/live",
  method: "GET"
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/system/log",
  method: "GET"
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/report/data/distribution",
  method: "GET"
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/print-bridge/report",
  method: "GET"
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/record/snapshot",
  method: "GET"
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/record/site-report/system-wide-data",
  method: "GET"
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/site/snapshot/live",
  method: "GET"
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/report/snapshot/live",
  method: "GET"
}];
exports.SocketQueueMapping = SocketQueueMapping;
var _default = SocketQueueMapping;
exports.default = _default;